// import { Default } from '..';

export class PaginatedResponse<T> {
  items: T[];
  reviews: T[];
  totalCount: number;
  limit?: number;
  page?: number;

  constructor() {
    this.items = [];
    this.totalCount = 0;
  }
}

export class Pagination {
  limit = 20;
  page = 0;
  totalCount?: number = null;

  constructor(pagination?: Partial<Pagination>) {
    if (pagination && pagination.limit) {
      this.limit = pagination.limit;
    }
    if (pagination && pagination.page) {
      this.page = pagination.page;
    }
  }
}
